import { message } from "antd";
import axiosInstance from "../../../helpers/axios";
import { responseDataFormate } from "../../../helpers/bycrypt";

export interface DayNoteData {
  _id?: string | null;
  date: string;
  user: any;
  employee_notes?: string;
  manager_notes?: string;
  created_by?: any;
  updated_by?: any;
  is_today?: boolean;
  can_edit_employee_notes?: boolean;
  has_admin_notes?: boolean;
  is_past_end_date?: boolean;
  employment_end_date?: string | Date | null;
  created_at?: string | null;
  updated_at?: string | null;
}

interface GetDayNoteParams {
  date?: string;
  user?: string;
  onSuccess?: (data: DayNoteData) => void;
  onError?: (error?: any) => void;
}

export const getDayNoteAPI =
  ({ date, user, onSuccess, onError }: GetDayNoteParams) =>
  async (dispatch: any) => {
    try {
      const params: any = {};
      if (date) params.date = date;
      if (user) params.user = user;

      const response = await axiosInstance.get(`/day-notes`, { params });
      const result = responseDataFormate(response.data);

      if (result?.success) {
        onSuccess?.(result.data);
      } else {
        onError?.(result);
      }
      return result;
    } catch (error: any) {
      console.error("Get Day Note error:", error);
      onError?.(error);
    }
  };

interface SaveDayNotePayload {
  date: string;
  user?: string;
  employee_notes?: string;
  manager_notes?: string;
}

interface SaveDayNoteParams {
  payload: SaveDayNotePayload;
  onSuccess?: (data: any) => void;
  onError?: (error?: any) => void;
}

export const saveDayNoteAPI =
  ({ payload, onSuccess, onError }: SaveDayNoteParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.post(`/day-notes`, payload);
      const result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message || "Day note saved successfully");
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to save day note");
        onError?.(result);
      }
      return result;
    } catch (error: any) {
      console.error("Save Day Note error:", error);
      const errorMessage = error?.response?.data?.message;
      if (errorMessage) message.error(errorMessage);
      onError?.(error);
    }
  };
